var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "861DF36B-93D3-46E5-A10F-2E05DD38AE3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 Z M9.81531017,12.2343767 C10.3153097,12.2343767 10.748903,12.652345 10.7528093,13.1640633 C10.748903,13.6835941 10.3153097,14.1015624 9.81531017,14.1015624 C9.29968566,14.1015624 8.87390482,13.6835941 8.87781106,13.1640633 C8.87390482,12.652345 9.29968566,12.2343767 9.81531017,12.2343767 Z M9.97937251,5.89063273 C11.5301523,5.89063273 12.6317137,6.68750697 12.6317137,8.05469317 C12.6317137,8.91146319 12.2165752,9.46878904 11.5673259,9.89181873 L11.4246836,9.98047258 C10.8074967,10.351566 10.5340595,10.7070344 10.526247,11.4687524 L10.526247,11.6015648 L9.04577965,11.6015648 L9.04577965,11.4687524 C9.04946888,10.177521 9.37719571,9.73296848 9.96643675,9.33874437 L10.0731224,9.26953576 C10.5535907,8.96484855 10.9246841,8.62500513 10.9246841,8.11328686 C10.9246841,7.57031863 10.4989033,7.21875647 9.97156002,7.21875647 C9.45984176,7.21875647 8.98718596,7.55859989 8.96374848,8.19531804 L7.37,8.19531804 C7.40515622,6.63281953 8.56140511,5.89063273 9.97937251,5.89063273 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\u0101kums",
    transform: "translate(-20.000000, -159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Question",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#A7A9AD",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarQuestion);
export default __webpack_public_path__ + "static/media/ic-sidebar-question.11085537e0e4b4bd300cb2945919e863.svg";
export { ForwardRef as ReactComponent };